<template lang="pug">
.cp-success-system
  .w
    .title 去电成功体系
    .subtitle 客户成功团队提供全生命周期伴随式服务
    .list
      .item(v-for="(v, index) in list", @click="handleClick(index)", :class="index === currentIndex ? 'item-active' : ''") {{ v.label }}
      .btn-light(ref="btn-light")
    .content.fix
      .left.fl
        svg.arc(ref="arc", width="157px" height="235px" viewBox="0 0 157 235" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink")
          g(id="客户成功" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
            path(d="M134.365018,233.577052 C147.489404,210.832252 155,184.43109 155,156.273159 C155,70.8198849 85.8279938,1.54631878 0.5,1.54631878 C0.333899948,1.54631878 0.167861115,1.54658127 0.00188389274,1.54631878" id="Path" stroke="#57E1F0" stroke-width="2.90223109")
        svg.circle(width="313px" height="320px" viewBox="0 0 313 320" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink")
          g(id="客户成功" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-opacity="0.339730525")
            path(d="M22.4893032,240.324036 L15.7749112,244.212742 L22.4893032,240.324036 C9.45503357,217.636551 2,191.326742 2,163.273159 C2,77.9868582 70.90195,8.81709772 156,8.54711184 L156,0.574515873 L156,8.54711184 C156.166605,8.54658326 156.333272,8.54631878 156.5,8.54631878 C241.827994,8.54631878 311,77.8198849 311,163.273159 C311,191.505873 303.449457,217.972474 290.26033,240.758194 L296.225089,244.212742 L290.26033,240.758194 C263.529312,286.939078 213.636671,318 156.5,318 C99.1844598,318 49.1583774,286.744298 22.4893032,240.324036 Z" id="椭圆形-2-copy" stroke="#4AA0FD" stroke-width="2.90223109")
        transition-group(name="scale", tag="div")
          img(v-for="(v, index) in list", v-if="index === currentIndex", :key="v.img", :src="v.img")
      .right.fl
        .right-item(v-for="v in currentItem.contentList")
          icon.icon(:iconClass="v.icon")
          .text-wrap
            p {{ v.title }}
            p {{ v.detail }}
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      currentIndex: 0,
      orginDeg: 120,
      list: [
        {
          label: '项目上线前',
          img: require('@/assets/shangxianqian.png'),
          contentList: [
            { title: '深刻理解客户业务场景', detail: '积极沟通，深入理解客户产品服务与业务目标', icon: 'iconxiangmushangxianqian' },
            { title: '针对客户关键业务节点做定向分析', detail: '分析业务流程，制定关键业务指标', icon: 'iconxiangmushangxianqian1' },
            { title: '优化方案性能', detail: '基于关键指标，调整业务策略，优化方案性能', icon: 'iconxiangmushangxianqian3' },
            { title: '定制话术交互方案', detail: '测试方案质量，按照业务转化表现不断迭代模型', icon: 'iconxiangmushangxianqian2' },
          ]
        },
        {
          label: '项目上线',
          img: require('@/assets/shangxian.png'),
          contentList: [
            { title: '每日业务流程监督', detail: '实时在线监督客户业务流程，关键指标降级告警', icon: 'iconxiangmushangxian2' },
            { title: '日终数据报表', detail: '日终统计业务转化，并做详尽数据定向分析，分析报告每日反馈', icon: 'iconxiangmushangxian' },
            { title: '智能语义增补', detail: '“云魁智能引擎“根据业务情况自动纠错，并做识别补偿，有效提升AI智能性', icon: 'iconxiangmushangxian1' },
            { title: '优化业务过程', detail: '每周分析客户业务转化率，根据节点指标优化业务过程', icon: 'iconxiangmushangxian3' },
          ]
        },
        {
          label: '合作期间',
          img: require('@/assets/hezuoqijian.png'),
          contentList: [
            { title: '半监督学习，语义纠偏', detail: '不定期通过AI集群训练提升客户分类识别精度，让客户转化结果有效清晰', icon: 'iconhezuoqijian' },
            { title: '7*12小时随时待命', detail: '7*12小时在线，5分钟内回复客户各类疑问，并提出合理建议', icon: 'iconhezuoqijian1' },
            { title: '每月系统功能迭代', detail: '以提升业务转化为宗旨，不断优化系统各项功能，保持产品功能更新迭代', icon: 'iconhezuoqijian2' },
            { title: '实时告警、降级熔断', detail: '关键业务指标自动监控，降级熔断，实时告警，为关键业务指标保驾护航', icon: 'iconhezuoqijian3' },
          ]
        },
      ],
      timer: null,
      isAuto: true,
    }
  },
  computed: {
    currentItem () {
      return this.list[this.currentIndex]
    }
  },
  methods: {
    handleClick (index) {
      if (this.isAuto) {
        clearInterval(this.timer)
        this.isAuto = false
        setTimeout(() => {
          this.start()
        }, 1000)
      }
      this.changeIndex(index)
    },
    changeIndex (index) {
      this.currentIndex = index
      this.$refs['btn-light'].style.left = 250 + index * 250 + 'px'

      this.$refs['arc'].style.transform = `rotate(${120 * index}deg)`
    },
    start () {
      this.isAuto = true
      this.timer = setInterval(() => {
        this.currentIndex++
        this.currentIndex %= 3
        this.changeIndex(this.currentIndex)
      }, 5000)
    }
  },
  mounted () {
    this.start()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="stylus">
.cp-success-system
  margin-bottom 200px
  .list
    position relative
    margin-top 60px
    margin-bottom 60px
    padding 0px 245px
    display flex
    justify-content space-between
    .item
      width 221px
      font-size 24px
      text-align center
      color rgba(158,234,250,1)
      cursor pointer
    .item-active
      color #fff
    .btn-light
      width 201px
      height 84px
      background url('../../../assets/btn-light.png') center / 100% no-repeat
      position absolute
      left 250px
      bottom -20px
      transition all .3s
  .content
    display flex
    .left
      position relative
      width 313px
      height 320px
      margin-left 130px
      margin-top 30px
      .circle
        position absolute
        left 0px
      .arc
        position absolute
        left 157px
        top 7px
        transition all .5s
        transform-origin 0px 156px
        transform rotate(0deg)
      img
        width 268px
        position absolute
        left 23px
        top 32px
      .scale-enter, .scale-leave-to
        transform scale(0)
      .scale-enter-active, .scale-leave-active
        transition transform 1s
    .right
      margin-left 170px
      .right-item
        margin-bottom 45px
        .icon
          float left
          font-size 28px
          margin-top 5px
        .text-wrap
          display inline-block
          vertical-align top
          width 400px
          margin-left 21px
          p
            &:first-child
              font-size 24px
              color rgba(244,245,247,1)
              margin-bottom 10px
            &:last-child
              color rgba(244,245,247,0.6)
        &:last-child
          margin-bottom 0px

</style>
